module.exports = "img/stickerpack-placeholder.877b5d0.png";